module.exports = __webpack_public_path__ + "img/pic_bg02.5420ec9d.png";